import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./BillingComponent.module.css";
import moment from "moment";
import { fetchMedicinesList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { LineItemObj } from "../../../utils/BillingConstants";
import { isEmpty, showAlert, getValWithVAT } from "../../../utils/CommonUtil";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";

function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}

export class Medicines extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_filter: "name",
            search_key: "",
            page: 1,
            sortName: "",
            sortOrder: "",
            sortBy: "",
            practitioner_id: "",
            patient_id: "",
            diagnosis_string: "",
            isDataFetched: false,
            list: [],
            errorMessage: "",
            isLoading: false,
            isModalOpen: false,
            duration: "",
            selectedRow: {}
        };
        this.setLoader = this.setLoader.bind(this);
    }


    componentDidMount = async () => {

        if (this.props.state &&
            this.props.state.requested_professional &&
            this.props.state.related_party) {

            this.setState({
                practitioner_id: this.props.state.requested_professional,
                patient_id: this.props.state.related_party
            })
        }

        if (this.props.diagnosis_string) {
            this.setState({
                diagnosis_string: this.props.diagnosis_string
            })
        }

        const payload = this.getPayload();
        await this.props.fetchMedicinesList(this.state.page, payload);
        if (this.props.medicinesListData &&
            this.props.medicinesListData.medicinesList &&
            this.props.medicinesListData.medicinesList.products &&
            this.props.medicinesListData.medicinesList.products.pageResult) {
            this.setState({
                list: this.props.medicinesListData.medicinesList.products.pageResult
            })
        }
        setTimeout(() => {
            this.setState({
                isDataFetched: true,
            });
        }, 1000);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.state.requested_professional !== this.props.state.requested_professional ||
            prevProps.state.related_party !== this.props.state.related_party) {

            //console.log("this.props for medicine", this.props);
            this.setState({
                practitioner_id: this.props.state.requested_professional,
                patient_id: this.props.state.related_party
            })

        }
        if (prevProps.diagnosis_string !== this.props.diagnosis_string) {
            this.setState({
                diagnosis_string: this.props.diagnosis_string
            })
        }
    }

    getPayload = () => {
        return {
            search_filter: this.state.search_filter,
            search_key: this.state.search_key,
        };
    }

    callListAPI = async () => {
        this.setState({
            list: [],
            isDataFetched: false,
        })

        const payload = this.getPayload();
        await this.props.fetchMedicinesList(this.state.page, payload);

        if (this.props.medicinesListData &&
            this.props.medicinesListData.medicinesList &&
            this.props.medicinesListData.medicinesList.products &&
            this.props.medicinesListData.medicinesList.products.pageResult) {
            this.setState({
                list: this.props.medicinesListData.medicinesList.products.pageResult
            }, () => {
                setTimeout(() => {
                    this.setState({
                        isDataFetched: true,
                    });
                }, 500);
            })
        } else {
            setTimeout(() => {
                this.setState({
                    isDataFetched: true,
                });
            }, 500);
        }

    }



    onSortChange = (sortName, sortOrder) => {
        let sortBy;
        if (sortOrder === "desc") {
            sortBy = "-" + sortName;
        } else {
            sortBy = sortName;
        }
        this.setState({
            sortName,
            sortOrder,
            sortBy,
            page: 1,
            isDataFetched: false,
        }, () => {
            this.callListAPI();
        });

    };

    onPageChange = (page, sizePerPage) => {
        this.setState({
            page,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        });
    };


    handleInputChange = (event) => {
        let val = event.target.value;

        this.setState({
            search_key: val,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        })
    }

    handleInputSelectChange = (event) => {
        let filterval = event.target.value;

        this.setState({
            [event.target.name]: filterval,
            page: 1,
            isDataFetched: false
        }, () => {
            this.callListAPI();
        })
    }

    handleDaysOfTherapyChange = (event) => {
        let val = event.target.value;
        this.setState({
            daysOfTherapy: val
        })
    }

    handleSubmit = () => {
        this.setState({
            isModalOpen: false
        }, () => {
            this.handleAddMedicine(this.state.selectedRow)
        })
    }

    // toggle a modal
    toggle = (val) => {
        this.setState((prevState) => ({
            isModalOpen: !prevState.isModalOpen,
            daysOfTherapy: "",
        }));
    }

    handleCheckMedicine = (row) => {

        if (!this.state.practitioner_id || !this.state.patient_id) {
            showAlert("Please select practitioner and patient first!");
            return false;
        }
        this.setState({
            selectedRow: row
        }, () => {
            this.toggle();
        })
    }

    handleAddMedicine = async (row) => {

       // console.log("Medicine data", row);
        this.setState({
            isLoading: true
        })

        const payload = { ...LineItemObj };

        payload.line_type = "medicine";
        payload.tariff_code = "0197";
        payload.days_of_therapy = this.state.daysOfTherapy;
        payload.nappi_code = row.nappiCodeFirstSixDigits.concat(row.nappiCodeSuffixLastThreeDigits);
        payload.description = row.name.substring(0, 70);
        payload.startdatetime = this.props.state && this.props.state.startdatetime ? moment(this.props.state.startdatetime).format("YYYY-MM-DD HH:mm"): "" ;
        payload.enddatetime =  this.props.state && this.props.state.enddatetime ? moment(this.props.state.enddatetime).format("YYYY-MM-DD HH:mm"): "" ;
        payload.quantity = row.standardPacksize;
        payload.dispencingQuantity = row.dispensingVolumePacksize;
        payload.doctor_id = this.state.practitioner_id;
        payload.diagnosis_code = this.state.diagnosis_string;
        payload.reference_id = payload.nappi_code;

        //calculation table of plan sub option of scheme.
        if (!isEmpty(this.props.planSubOptionLookupData) && this.props.planSubOptionLookupData.ethicalCalcs &&
            this.props.planSubOptionLookupData.ethicalCalcs.length > 0) {
            let ethicalCalcs = this.props.planSubOptionLookupData.ethicalCalcs;
            let calculationObj = ethicalCalcs.find((item) => {
                // checking drug schedule and cost value in ethical calculation list.
                return (Number(row.drugSchedule) >= Number(item.scheduleFrom) &&
                    Number(row.drugSchedule) <= Number(item.scheduleTo) &&
                    Number(row.singleExitPrice) >= Number(item.costFrom) &&
                    Number(row.singleExitPrice) <= Number(item.costTo))
            })

            if (calculationObj) {
                payload.base_price = Number(row.singleExitPrice)/Number(row.standardPacksize);

                // add vat price to fixed fee of calculation table.
                payload.fixedFeeWithVAT = getValWithVAT(calculationObj.fixedFee)
                payload.markupPercent = calculationObj.markUpPercentage;

                // add vat price to single exit fee of medicine.
                let singleExitPriceWithVAT = getValWithVAT(row.singleExitPrice);
                let fixedFeeWithVAT = getValWithVAT(calculationObj.fixedFee);
                let markupPercent = Number(calculationObj.markUpPercentage)

                //calculating final price value by adding markup percentage
                let finalPrice = singleExitPriceWithVAT + fixedFeeWithVAT;
                let markupValue = markupPercent ? (finalPrice * (Number(markupPercent) / 100)) : 0;
                let price = finalPrice + markupValue;
                payload.price = price ? Number(price.toFixed(2)) : 0;
                payload.calculatedPrice = price ? Number(price.toFixed(2)) : 0;
            }

        }


       // console.log("payload", payload)

        this.setState({
            isLoading: false
        })
        this.props.updateState(payload);

        // setTimeout(() => {
        //   this.setState({
        //     errorMessage: ""
        //   });
        // }, 3000);
    }

    // Adding actions edit and delete icons
    actionsFormatter = (cell, row) => {
        return (
            <div>

                {/* <Link title="Add Medicine" onClick={() => this.handleCheckMedicine(row)}>
                    <i className="fa fa-plus billing-plus-icon ml-2"></i>
                </Link> */}

                <button
                    type="button"
                    title="Add Medicine"
                    onClick={() => this.handleCheckMedicine(row)}
                    className="btn btn-link p-0"
                >
                    <i className="fa fa-plus billing-plus-icon ml-2"></i>
                </button>
            </div>
        );
    }

    formatDescription = (cell, row) => {
        if (!cell) {
            return "Not Available"
        }

        return (
            <div className="description" title={cell}>{cell}</div>
        )
    }

    formatCode = (cell, row) => {
        if (!cell) {
            return "Not Available"
        }

        return cell.concat(row.nappiCodeSuffixLastThreeDigits ? row.nappiCodeSuffixLastThreeDigits : "");
    }

    /**
     * This method will be called when there is not data or data is being fetched to show the loader.
     */
    setLoader() {
        if (this.state.isDataFetched) {
            return <p>There is no data to display</p>;
        } else {
            return (
                <div>
                    <img src={ttmLoader} alt='loader' className="loader-image" />
                </div>
            );
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data or Not available string
    */
    checkValidData = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data;
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data with first letter capital or Not available string
    */
    detailFormatter = (data) => {
        if (!data) {
            return "Not Available";
        } else {
            return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
        }
    }

    //   /**
    //    * This method will clear all the filters which are selected.
    //    */
    //   handleClearFilters = () => {
    //     this.setState({
    //       page: 1,
    //       sortName: "",
    //       sortOrder: "",
    //       sortBy: "",
    //       isDataFetched: false
    //     }, () => {
    //       this.callListAPI();
    //     })
    //   }


    /**
   * This will return filter form HTML for the render method.
   */
    getHeaderFilter = () => {

        return (
            <div className={`row form-group `}>

                <div class="col-md-12 d-flex flex-column flex-md-row">
                    <input
                        type="text"
                        className={`form-control ${style.inputSearch}`}
                        name="search_key"
                        placeholder="Search here"
                        onChange={this.handleInputChange}
                        value={this.state.search_key}
                    // onChange={this.onSearchChange}
                    />
                    <div class="d-flex mt-2 mt-md-0">
                        <label class="form-control invoice-filter-label border-0">in</label>
                        <select
                            className="form-control"
                            id="search_filter"
                            name="search_filter"
                            onChange={this.handleInputSelectChange}
                            value={this.state.search_filter}
                        >
                            <option value="nappi_code">Nappi code</option>
                            <option value="name">Name</option>
                        </select>
                    </div>
                </div>

            </div>
        );
    };

    render() {
        const listData = this.props.medicinesListData &&
            this.props.medicinesListData.medicinesList &&
            this.props.medicinesListData.medicinesList.products;

        return (
            <div className="inventory-tab-wrapper flex-wrap">
                <div className="row">
                    {/* <div className="col-md-12 d-flex justify-content-md-end">
              <a className="clearFilters"
                href="javascriptVoid:0"
                onClick={this.handleClearFilters}>
                Clear Filters
                </a>
            </div> */}
                    <div className="col-md-12">
                        {this.getHeaderFilter()}
                    </div>
                </div>

                <div className="row">
                    <div className={`col-md-12`}>
                        <BootstrapTable
                            remote={true}
                            bordered={false}
                            data={this.state.list}
                            version="4"
                            search={false}
                            pagination
                            fetchInfo={{
                                dataTotalSize: listData && listData.totalCount ? listData.totalCount : 0,
                            }}
                            options={{
                                searchvalue: "",
                                sortName: this.state.sortName,
                                sortOrder: this.state.sortOrder,
                                onSortChange: this.onSortChange,
                                // onSearchChange: this.onSearchChange,
                                sizePerPage: 5,
                                page: this.state.page,
                                onPageChange: this.onPageChange,
                                noDataText: this.setLoader(),
                            }}>
                            <TableHeaderColumn
                                dataField="nappiCodeFirstSixDigits"
                                isKey={true}
                                dataFormat={(cell, row) => this.formatCode(cell, row)}
                                width="15%"
                            >
                                Nappi Code
                </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="name"
                                dataFormat={(cell, row) => this.formatDescription(cell, row)}
                                width="75%"
                            >
                                Name
               </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="id"
                                width="10%"
                                dataFormat={this.actionsFormatter}
                            >
                                Add
               </TableHeaderColumn>
                        </BootstrapTable>
                        {this.state.isLoading ? (
                            <div className={"loadingWrapper"}>
                                <img
                                    src={ttmLoader}
                                    alt="loader"
                                    className={style.loading}
                                />
                            </div>
                        ) : (
                                <div className={"textCenter"}>
                                    {this.state.errorMessage && (
                                        <p className=" error-message">
                                            {this.state.errorMessage}
                                        </p>
                                    )}
                                </div>
                            )}
                        <Modal
                            isOpen={this.state.isModalOpen}
                            toggle={this.toggle}
                            className={style.deleteReason}
                            centered
                        >
                            <ModalHeader
                                toggle={this.toggle}
                                className={style.deleteReasonHeader}
                            >
                                Days of Therapy
            </ModalHeader>
                            <ModalBody>
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        daysOfTherapy: Yup.string().required("Days of Therapy is required")
                                            .matches(/^[0-9]*$/, "Enter numbers only"),
                                    })}
                                    onSubmit={this.handleSubmit}
                                >
                                    {({ errors, status, touched }) => (
                                        <Form>
                                            <div className={style.deleteReasonHeadingWrapper}>
                                                <p>
                                                    Please enter days of therapy{" "}
                                                </p>
                                            </div>
                                            <div className={style.deleteReasonFormWrapper}>
                                                <div className="form-group">
                                                    <Field
                                                        name="daysOfTherapy"
                                                        placeholder="Days"
                                                        className={
                                                            "form-control" +
                                                            (errors.daysOfTherapy && touched.daysOfTherapy
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleDaysOfTherapyChange}
                                                        value={this.state.daysOfTherapy}

                                                    >
                                                    </Field>
                                                    <ErrorMessage
                                                        name="daysOfTherapy"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />

                                                </div>
                                                <div className={`row ${style.deleteBtnWrapper}`}>
                                                    <div className="col-lg-12">
                                                        <div>
                                                            <button
                                                                type="submit"
                                                                disabled={this.state.successMessage}
                                                                className={`mr-4 ${style.deleteBtn}`}
                                                            >
                                                                Proceed
                        </button>
                                                            <button
                                                                type="button"
                                                                disabled={this.state.successMessage}
                                                                className={style.cancelBtn}
                                                                onClick={this.toggle}
                                                            >
                                                                Cancel
                        </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Form>
                                    )}

                                </Formik>
                            </ModalBody>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

// export default Users;
const mapStateToProps = (state) => {
    return {
        medicinesListData: state.medicinesList,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchMedicinesList: (page, payload) => dispatch(fetchMedicinesList(page, payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Medicines);
